import { api } from '@core/api';
import type { GiftCardExperience, GiftCardDetails, BuyGiftCardPayload } from '../types';

/**
 * Fetch gift card experiences for a restaurant.
 * GET /api/{lang}/get-gift-card-experiences/{restaurantId}
 */
export async function getGiftCardExperiences(
  lang: string,
  restaurantId: number,
): Promise<GiftCardExperience[]> {
  const data = await api.get<GiftCardExperience[]>(
    `/api/${lang}/get-gift-card-experiences/${restaurantId}`,
  );
  return data.map(exp => ({
    ...exp,
    prices: exp.prices.map(p => {
      const n = Number(p);
      return Number.isFinite(n) ? n : 0;
    }),
  }));
}

/**
 * Purchase a gift card.
 * POST /api/{lang}/buy-gift-card
 */
export async function buyGiftCard(
  lang: string,
  payload: BuyGiftCardPayload,
): Promise<{ uniqueId?: string }> {
  const response = await api.post<{ uniqueId?: string } | null>(`/api/${lang}/buy-gift-card`, payload);
  return { uniqueId: response?.uniqueId || undefined };
}

/**
 * Fetch gift card details by token.
 * GET /api/{lang}/get-gift-card/{token}
 */
export async function getGiftCard(
  lang: string,
  token: string,
): Promise<GiftCardDetails> {
  return api.get<GiftCardDetails>(
    `/api/${lang}/get-gift-card/${token}`,
  );
}
